<script setup lang="ts">
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import { computed, watchEffect } from 'vue';
import ContinueButton from './shared/ContinueButton.vue';
import WelcomeSection from './shared/WelcomeSection.vue';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import ExternalLink from 'gpcore-uikit/components/Component.ExternalLink.vue';
import useGlobalConfig from '@panel/composables/useGlobalConfig';
import useSetupValidation from './composables/useSetupValidation';

const isValid = defineModel<boolean>('isValid', {
  default: false,
});

const emit = defineEmits<{
  nextButtonClicked: [];
}>();

const projectStore = useProjectStore();

const nodeLimit = computed(() => projectStore.projectNodeLimit);
const { userIsallowedToCreateNodes } = useSetupValidation();

watchEffect(() => {
  isValid.value = userIsallowedToCreateNodes.value;
});

const { support } = useGlobalConfig();
</script>

<template>
  <WelcomeSection
    name="Node Limit"
    :is-done="userIsallowedToCreateNodes"
    v-playwright="'welcome-node-limit-section'"
  >
    <template #content>
      <p v-if="userIsallowedToCreateNodes">You are eligible to create {{ nodeLimit }} nodes.</p>
      <p v-else>
        Please contact our
        <ExternalLink :url="support.url" class="tw-text-gp-cyan"> sales team </ExternalLink>
        to onboard your account. Currently, the project owner is not fully activated and can't
        create nodes. Please request a node limit for the project owner.
      </p>
    </template>

    <template #footer>
      <ContinueButton
        label="Finish"
        class="tw-mx-auto tw-mt-4"
        :disabled="!userIsallowedToCreateNodes"
        v-playwright="'welcome-node-limit-section-finish-btn'"
        :icon="faCheck"
        @click="emit('nextButtonClicked')"
      />
    </template>
  </WelcomeSection>
</template>

<style scoped></style>
